/* import {EventType} from '@azure/msal-browser'; */
import {useMsal, useAxios} from '@sttedra_ui/framework';
import axios from 'axios';

const {base} = useAxios();

let isRefreshing = false;
let failedQueue = [];

function processQueue(error, token = null) {
  failedQueue.forEach(({resolve, reject}) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
}

function baseInterceptors() {
  base.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Si no hay response (error de red, CORS, etc.), no intentamos refrescar
      if (!error.response) {
        return Promise.reject(error);
      }

      const status = error.response.status;
      const message = error.response.data?.message;

      // Aquí decides qué consideras "token inválido/expirado"
      const isTokenInvalidOrExpired = status === 401 && (message?.includes('IDX10511') ||
         message?.includes('token') || message?.includes('Token') ||
         message?.includes('no autorizada'));

      // Si no es 401 "de token" o ya se reintentó, salimos
      if (!isTokenInvalidOrExpired || originalRequest._retry) {
        return Promise.reject(error);
      }

      // Si ya se está renovando el token, encolamos la petición
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({resolve, reject});
        }).then((token) => {
          originalRequest.headers.Authorization = token;
          return axios(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const {modelRef} = useMsal();
        const instance = modelRef.value.instance;

        // Asegúrate de que defaulRequest tenga tu scope de API:
        // defaulRequest: { scopes: [MSAL_REQUEST_DEFAULT_SCOPE] }
        const tokenResponse = await instance.acquireTokenSilent({
          ...modelRef.value.defaulRequest,
          forceRefresh: true,
        });

        const newAuthHeader = `${tokenResponse.tokenType} ${tokenResponse.accessToken}`;

        // Actualizamos el header de la petición original
        originalRequest.headers.Authorization = newAuthHeader;

        // Resolvemos la cola con el nuevo token
        processQueue(null, newAuthHeader);

        // Reintentamos la petición original
        return axios(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);

        // Si falla la renovación silenciosa, forzamos login
        try {
          const {logIn} = useMsal();
          await logIn();
        } catch (_) {
          // Si también falla el login, no hay más que hacer
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    },
  );
}


export function setupMsalInterceptor() {
  baseInterceptors();
}

